import { ProductAggregateDocument, ProductVariantDocument } from '@/types/manage.types';
import { AddToCartButton } from '../cart/AddToCartButton';

interface AddToCartSectionProps {
  product: ProductAggregateDocument;
  selectedVariant: ProductVariantDocument | null;
}

export function AddToCartSection({ product, selectedVariant }: AddToCartSectionProps) {
  if (!selectedVariant) return null;

  return (
    <div className="flex justify-between items-center mt-8">
      <p className="font-semibold text-gray-500 italic">${selectedVariant.price}</p>
      <AddToCartButton product={product} selectedVariant={selectedVariant} />
    </div>
  );
}
